// Olli's own menu icons. 24 grid, 1.75 stroke, round caps, like Lucide.
// Each icon has one accent shape: faint when idle, sun when its page is open,
// ink when it sits on the sun pill. The AI agents icon is Olli's two bubbles.

const ACCENT = {
  idle: "fill-paper/15 group-hover:fill-paper/35",
  active: "fill-sun",
  onSun: "fill-ink",
};
// Small solid marks (dots) read as part of the line when idle
const DOT = {
  idle: "fill-current",
  active: "fill-sun",
  onSun: "fill-ink",
};
// Detail drawn on top of the accent shape
const DETAIL = {
  idle: "stroke-current",
  active: "stroke-ink",
  onSun: "stroke-sun",
};

function draw(name, a, dot, d) {
  switch (name) {
    case "ask":
      return (
        <>
          <circle cx="16" cy="7.5" r="4.5" className={a} />
          <circle cx="10" cy="14" r="6.25" />
          <path d="M5.4 18.4c-.3 1.4-1 2.3-2 2.9 1.9.2 3.5-.3 4.7-1.3" />
        </>
      );
    case "dashboard":
      return (
        <>
          <rect x="3" y="3" width="8" height="9" rx="2.5" className={a} />
          <rect x="13" y="3" width="8" height="5" rx="2.5" />
          <rect x="13" y="12" width="8" height="9" rx="2.5" />
          <rect x="3" y="16" width="8" height="5" rx="2.5" />
        </>
      );
    case "wallet":
      return (
        <>
          <path d="M6.5 5.5 15.6 3a1.5 1.5 0 0 1 1.9 1.45V5.5" />
          <rect x="3" y="5.5" width="18" height="15" rx="3.5" />
          <rect x="14" y="10.25" width="7" height="5.5" rx="2.75" className={a} />
        </>
      );
    case "crm":
      return (
        <>
          <circle cx="9" cy="8" r="3.5" />
          <path d="M2.5 20c.6-3.4 3.3-5.5 6.5-5.5s5.9 2.1 6.5 5.5" />
          <circle cx="17" cy="9" r="2.75" className={a} />
          <path d="M17 14.5c2.4.2 4.2 2 4.5 4.5" />
        </>
      );
    case "patients":
      return (
        <>
          <circle cx="10" cy="7.5" r="3.5" />
          <path d="M3.5 20c.6-3.5 3.3-5.5 6.5-5.5 1.2 0 2.3.3 3.2.8" />
          <circle cx="17.5" cy="17.5" r="4" className={a} />
          <path d="M17.5 15.75v3.5M15.75 17.5h3.5" className={d} />
        </>
      );
    case "appointments":
      return (
        <>
          <rect x="3" y="4.5" width="18" height="16.5" rx="3.5" />
          <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
          <rect x="7" y="12.5" width="4.5" height="4.5" rx="1.25" className={a} />
        </>
      );
    case "schedules":
      return (
        <>
          <path d="M12 12V3a9 9 0 0 1 9 9z" className={a} />
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3.5 2" />
        </>
      );
    case "treatment":
      return (
        <>
          <rect x="5" y="4" width="14" height="17.5" rx="3" />
          <path d="M9 4V3.5A1.5 1.5 0 0 1 10.5 2h3A1.5 1.5 0 0 1 15 3.5V4" />
          <rect x="8" y="11.5" width="8" height="5" rx="2.5" className={a} />
          <path d="M12 11.5v5" className={d} />
        </>
      );
    case "whatsapp":
      return (
        <>
          <path d="M12 3.5a8.5 8.5 0 0 0-7.35 12.76L3.5 20.5l4.35-1.12A8.5 8.5 0 1 0 12 3.5z" />
          <circle cx="8.25" cy="12" r="1.15" stroke="none" className={dot} />
          <circle cx="12" cy="12" r="1.15" stroke="none" className={dot} />
          <circle cx="15.75" cy="12" r="1.15" stroke="none" className={dot} />
        </>
      );
    case "ai":
      return (
        <>
          <circle cx="17" cy="7" r="3.8" className={a} />
          <circle cx="10" cy="14" r="6.5" />
          <path d="M5.4 18.6 3.5 21.5l4-1" />
        </>
      );
    case "support":
      return (
        <>
          <path d="M4.5 15v-3a7.5 7.5 0 0 1 15 0v3" />
          <rect x="3" y="13" width="4" height="6.5" rx="2" className={a} />
          <rect x="17" y="13" width="4" height="6.5" rx="2" className={a} />
          <path d="M19 19.5c0 1.4-1.1 2.5-2.5 2.5H14" />
        </>
      );
    case "marketing":
      return (
        <>
          <path d="M14.5 5.5v13l-6-3H6a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3h2.5z" className={a} />
          <path d="M8.5 15.5 9.7 20H12" />
          <path d="M18 9.5a3.5 3.5 0 0 1 0 5" />
        </>
      );
    case "settings":
      return (
        <>
          <path d="M4 7h8M18 7h2M4 17h2M12 17h8" />
          <circle cx="15" cy="7" r="2.75" />
          <circle cx="9" cy="17" r="2.75" className={a} />
        </>
      );
    default:
      return null;
  }
}

export function NavIcon({ name, tone = "idle", className = "h-5 w-5" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={`shrink-0 ${className}`}
    >
      {draw(name, ACCENT[tone], DOT[tone], DETAIL[tone])}
    </svg>
  );
}
